<patron-button color="success" (click)="save.emit({ newMessage: false })" [disabled]="isSaving!">
  @if (isSaving) {
    <i class="pi pi-spin pi-spinner"></i>
  }
  @if (!isSaving) {
    <i class="pi pi-save"></i>
  }
  Salvar
</patron-button>
